import { Injectable } from '@angular/core';
import { IdentityProviderMessagingTokenParticipant } from '@repo/shared/src/services/identity-provider/identity-provider.types';
import { ConversationParticipantDetails } from '@repo/shared/src/services/messaging-service/messaging-service.types';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NewConversationService {
  firstDestinataire = new BehaviorSubject<IdentityProviderMessagingTokenParticipant | null>(null);
  private firstDestinataireObservable$ = this.firstDestinataire.asObservable();

  arraySecondaryDestinataire = new BehaviorSubject<IdentityProviderMessagingTokenParticipant[] | []>([]);
  private arraySecondaryDestinataireObservable$ = this.arraySecondaryDestinataire.asObservable();

  arrayTargetAdded = new BehaviorSubject<ConversationParticipantDetails[] | []>([]);
  private arrayTargetAddedObservable$ = this.arrayTargetAdded.asObservable();

  private newConversation = new BehaviorSubject<boolean>(false);
  private newConversationObservable$ = this.newConversation.asObservable();
  private previousNewConversation = new BehaviorSubject<boolean>(false);
  private wasNewConversation = new BehaviorSubject<{ wasNewConversation: boolean, audioButtonClicked: boolean }>({ wasNewConversation: false, audioButtonClicked: false });
  private wasNewConversationObservable$ = this.wasNewConversation.asObservable();


  // Utilisé dans le cas où le lien vers la messagerie est redirigé depuis la prise de rendez-vous (RSP_1298)
  private redirectedFromAppointment = new BehaviorSubject<boolean>(false);

  get wasNewConversation$(): Observable<{ wasNewConversation: boolean, audioButtonClicked: boolean }> {
    return this.wasNewConversationObservable$;
  }

  private previousNewConversationObservable$ = this.previousNewConversation.asObservable();

  get firstDestinataire$(): Observable<IdentityProviderMessagingTokenParticipant | null> {
    return this.firstDestinataireObservable$;
  }

  get newConversation$(): Observable<boolean> {
    return this.newConversationObservable$;
  }

  get isNewConversation(): boolean {
    return this.newConversation.value;
  }

  get previousNewConversation$(): Observable<boolean> {
    return this.previousNewConversationObservable$;
  }

  get previousIsNewConversation(): boolean {
    return this.previousNewConversation.value;
  }

  get arraySecondaryDestinataire$(): Observable<IdentityProviderMessagingTokenParticipant[] | []> {
    return this.arraySecondaryDestinataireObservable$;
  }

  get arrayTargetAdded$(): Observable<ConversationParticipantDetails[] | []> {
    return this.arrayTargetAddedObservable$;
  }

  get isRedirectedFromAppointment(): boolean {
    return this.redirectedFromAppointment.value;
  }

  modifyDestinataire(destinataire: IdentityProviderMessagingTokenParticipant) {
    this.firstDestinataire.next(destinataire);
  }

  setSecondaryDestinataire(arrayDestinataire: IdentityProviderMessagingTokenParticipant[] | []) {
    this.arraySecondaryDestinataire.next(arrayDestinataire);
  }

  setArrayTargetAdded(arrayTarget: ConversationParticipantDetails[]) {
    this.arrayTargetAdded.next(arrayTarget);
  }

  removeIndexInArraySecondaryDestinataire(destinataire: IdentityProviderMessagingTokenParticipant) {
    const newArray: IdentityProviderMessagingTokenParticipant[] = this.arraySecondaryDestinataire.getValue().slice();

    newArray.forEach((item, index) => {
      if (item.id === destinataire.id) {
        newArray.splice(index, 1);
      }
    });

    this.arraySecondaryDestinataire.next(newArray);
  }

  removeIndexInArrayTargetAdded(target: ConversationParticipantDetails) {
    const newArray: ConversationParticipantDetails[] = this.arrayTargetAdded.getValue().slice();

    newArray.forEach((item, index) => {
      if (item.id === target.id) {
        newArray.splice(index, 1);
      }
    });
    this.arrayTargetAdded.next(newArray);
  }

  setWasNewConversation(newValue: boolean, audioButtonClicked: boolean = false): void {
    this.wasNewConversation.next({ wasNewConversation: newValue, audioButtonClicked });
  }

  changeIsNewConversation(value: boolean) {
    this.previousNewConversation.next(this.isNewConversation);
    this.newConversation.next(value);
  }

  setRedirectedFromAppointment(redirectedFromAppointment: boolean) {
    this.redirectedFromAppointment.next(redirectedFromAppointment);
  }
}
